import { useState } from 'nuxt/app'
import type { Headers } from '../types/module'

export function useStateHeaders() {
    return useState<{ [K in keyof Headers]?: Headers[K] | null }>(() => ({}))
}
